import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useInvalidateUseGetAgencyInformationForUser } from '@urbanx/agx.agencies.client';
import { useStoreAccessCode } from '@urbanx/agx.rpdata.client';
import useQuery from 'hooks/useQuery';
import getIntegrationAuthorizationReturnPath from './getIntegrationAuthorizationReturnPath';

const RpDataAuthenticated = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const invalidateAgencyInformation = useInvalidateUseGetAgencyInformationForUser();
  const returnPath = getIntegrationAuthorizationReturnPath(query.get('state'));
  const { storeAccessCode } = useStoreAccessCode({
    onSuccess: async () => {
      await invalidateAgencyInformation();
      navigate(returnPath, { replace: true });
    },
    onError: () => navigate(`${returnPath}?rpDataErrorCode=connection-failed`, { replace: true }),
  });

  useEffect(() => {
    const code = query.get('code');

    if (!code) {
      navigate(`${returnPath}?rpDataErrorCode=authorization-failed`, { replace: true });
      return;
    }

    void storeAccessCode({ code }).catch(() => undefined);
  }, [navigate, query, returnPath, storeAccessCode]);

  return null;
};

export default RpDataAuthenticated;
